import React from 'react';
import "./CheckOutPay.css";

export default function CheckOutPay() {
  return (
    <div>CheckOutPay</div>
  )
}
